@if (eligibility(); as e) {
  <div class="elig" [class.open]="open()">
    @if (static() || e.verdict === 'not_checked' || pending()) {
      <div class="elig-static">
        <span class="elig-label">{{ 'eligibility.requirements' | translate }}</span>{{ ' ' }}
        <ng-container *ngTemplateOutlet="verdict; context: { $implicit: e }"></ng-container>
      </div>
    } @else {
      <button type="button" class="elig-toggle" (click)="toggle($event)" [attr.aria-expanded]="open()">
        <span class="elig-label">{{ 'eligibility.requirements' | translate }}<svg class="chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></span>{{ ' ' }}
        <ng-container *ngTemplateOutlet="verdict; context: { $implicit: e }"></ng-container>
      </button>
    }
    @if (!open() && decidingText(); as r) {
      <div class="elig-reason">{{ r }}</div>
    }
    @if (open()) {
      <ul class="elig-list" (click)="$event.stopPropagation()">
        @for (c of checkable(); track c.id) {
          <li class="elig-item">
            <span class="elig-what">{{ c.label }}</span>{{ ' ' }}
            <span [class]="'elig-verdict ' + tone(c.verdict)">{{ conditionVerdict(c) }}</span>{{ ' ' }}
            @if (reasonText(c.reason); as r) { <span class="elig-why">{{ r }}</span>{{ ' ' }} }
            @for (row of c.rows; track row.id) {
              <span class="elig-row">{{ rowLine(row) }}@if (row.note) { <span class="elig-row-note">{{ row.note }}</span> }</span>{{ ' ' }}
            }
          </li>
        }
        @for (c of other(); track c.id) {
          <li class="elig-item">
            <span class="elig-what">{{ c.label }}</span>{{ ' ' }}
            <span class="elig-verdict is-muted">{{ conditionVerdict(c) }}</span>{{ ' ' }}
          </li>
        }
        @if (e.gaps.length) {
          <li class="elig-item">
            <span class="elig-what">{{ 'eligibility.gaps' | translate }}</span>{{ ' ' }}
            @for (g of e.gaps; track g.row_id + g.kind) {
              <span class="elig-why">{{ g.title }}: {{ 'eligibility.gap.' + g.kind | translate }}</span>{{ ' ' }}
            }
          </li>
        }
      </ul>
    }
  </div>
}

<ng-template #verdict let-e>
  <span class="verdict">
    @if (pending()) {
      <span class="v-w is-muted">{{ 'eligibility.being_checked' | translate }}</span>
    } @else if (e.verdict === 'not_checked') {
      <span class="v-w is-muted">{{ 'eligibility.condition.not_checked' | translate }}</span>
    } @else {
      <span class="v-n">{{ e.eisen_met }}/{{ e.eisen_total }}</span>{{ ' ' }}
      <span [class]="'v-w ' + tone(e.verdict)">{{ 'eligibility.verdict.' + e.verdict | translate }}</span>
    }
  </span>
</ng-template>
